module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.state.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.state.userInfo.messages), function(item, key, index) {
    return _c('li', [_c('a', {
      attrs: {
        "id": ""
      },
      on: {
        "click": function($event) {
          _vm.ClickNoti(index, item.id, item.sender)
        }
      }
    }, [_c('h4', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('small', [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.update_time, 'from', 'now')))])])]), _vm._v(" "), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.message))]), _vm._v(" ")])])
  }), _vm._v(" ")], true), _vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.notifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.notifications)) + " notification(s)")]), _vm._v(" "), (_vm.state.userInfo.notifications.length > 0) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.state.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.state.userInfo.tasks)) + "  task(s)")]), _vm._v(" "), (_vm.state.userInfo.tasks.length > 0) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.state.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])]), _vm._v(" "), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.demo.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.demo.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.demo.displayName != '') ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(4)])]) : _vm._e()])])])])])]), _vm._v(" "), _vm._v(" "), _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.demo.displayName))])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('li', {
    staticClass: "pageLink active",
    attrs: {
      "id": "trip"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Trip List'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-road"
  }), _c('span', {
    staticClass: "page"
  }, [_vm._v("Trip List")])])]), _vm._v(" "), _c('li', {
    staticClass: "pageLink",
    attrs: {
      "id": "driver"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Driver List'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-taxi"
  }), _c('span', {
    staticClass: "page"
  }, [_vm._v("Driver List")])])]), _vm._v(" "), _c('li', {
    staticClass: "pageLink",
    attrs: {
      "id": "device"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Device List'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _c('span', {
    staticClass: "page"
  }, [_vm._v("Device List")])])]), _vm._v(" "), _c('li', {
    staticClass: "pageLink",
    attrs: {
      "id": "map"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._m(6)]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" ")]), _vm._v(" ")]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$route.name) + "\n\t\t\t\t\t"), _c('small', [_vm._v(_vm._s(_vm.$route.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(7), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name))])])]), _vm._v(" "), _c('router-view')]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + " "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("United Taxi")]), _vm._v(".")]), _vm._v(" All rights reserved.\n\t\t")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": "/static/img/logo_sm.png",
      "alt": "Logo"
    }
  })]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "container logo-lg"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/logo_sm.png",
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_vm._v("United Taxi")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDesign some buttons\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])]), _vm._v(" ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-sign-out text-aqua"
  }), _vm._v(" Log Out\n\t\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/admin/index.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _c('span', {
    staticClass: "page"
  }, [_vm._v("Map View")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d5b13ae4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 172
// module chunks = 2